module.exports = __webpack_public_path__ + "static/media/full.cd402611.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/retained/full.png
// module id = 70
// module chunks = 0